import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { fillLinkTokens, SpanishAcknowledgmentContent } from 'projects/borrower-app/src/app/services/spanish-acknowledgment';

/**
 * LLS-886 §5: the lender's Spanish language acknowledgment. The statement must be checked to continue in
 * Spanish; the secondary action continues in English instead. (E-consent stays in its own wizard step.) Closes with true (accepted) or false. Lender HTML
 * goes through Angular's [innerHTML] sanitization. Its own strings are always Spanish: a signed-out ES click asks
 * before Spanish is activated.
 */
@Component({
  selector: 'spanish-acknowledgment-dialog',
  templateUrl: './spanish-acknowledgment-dialog.component.html',
  standalone: false,
})
export class SpanishAcknowledgmentDialogComponent {
  @Input() content: SpanishAcknowledgmentContent;
  @Input() legalHref = '';

  acknowledged = false;

  constructor(readonly activeModal: NgbActiveModal) {}

  html(value: string | null | undefined): string {
    return fillLinkTokens(value ?? '', this.legalHref);
  }

  get canContinue(): boolean {
    return this.acknowledged;
  }
}
